/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeedbackDataGeo } from './feedbackDataGeo';


export interface FeedbackData { 
    category?: string;
    geo: FeedbackDataGeo;
    description?: string;
    visibility: FeedbackData.VisibilityEnum;
    businessActivity?: string;
    proMode?: boolean;
    metadata?: string;
}
export namespace FeedbackData {
    export type VisibilityEnum = 'VISIBILITY_PUBLIC' | 'VISIBILITY_PRIVATE';
    export const VisibilityEnum = {
        PUBLIC: 'VISIBILITY_PUBLIC' as VisibilityEnum,
        PRIVATE: 'VISIBILITY_PRIVATE' as VisibilityEnum
    };
}
